import React from 'react'
import { useRecoilState } from 'recoil'
import { userState } from '@/common/state/atoms/user-state'

export type AccountDetailsProps = {
  className?: string
}

const AccountDetails = ({
  className = '',
}: AccountDetailsProps): JSX.Element => {
  const [user] = useRecoilState(userState)
  return (
    <div
      className={`${className} bg-white shadow overflow-hidden sm:rounded-lg`}
    >
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium">Accountgegevens</h3>
      </div>
      <div className="border-t border-gray-200">
        <dl>
          <div className="bg-gray-50 px-4 py-5 md:grid  lg:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Naam</dt>
            <dd className="mt-1 text-sm text-default sm:mt-0 sm:col-span-2">
              {user?.fullName}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 md:grid lg:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium">Email address</dt>
            <dd className="mt-1 text-sm text-default sm:mt-0 sm:col-span-2">
              {user?.email}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  )
}

export default AccountDetails
